import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { AgreementIntegrationConfig } from "@modules/erpIntegrations/types";
import { ConfigFormValues } from "@modules/erpIntegrations/validations";
import { getErpErrorMessage } from "@modules/erpIntegrations/utils";

import { createConfigService } from "./service";
import { UseCreateConfigMutationOptions } from "./types";

export function useCreateConfigMutation(options?: UseCreateConfigMutationOptions) {
  const { open } = useNotification();

  return useMutation<AgreementIntegrationConfig, ApiError, ConfigFormValues>({
    mutationFn: createConfigService,
    ...options,
    onError: (error, variables, context) => {
      open?.({
        type: "error",
        message: getErpErrorMessage(error),
      });
      options?.onError?.(error, variables, context);
    },
  });
}
